<table nxTable zebra  nxSort (sortChange)="sortTable($event)">
    <thead>
        <tr nxTableRow>
            <th nxHeaderCell nxSortHeaderCell="zone">
                Zone
            </th>
            <th nxHeaderCell nxSortHeaderCell="state_Name">
                State Name
            </th>
            <th nxHeaderCell nxSortHeaderCell="city_Name">
                City Name
            </th>
            <th nxHeaderCell nxSortHeaderCell="dealerOrWorkshopCode">
                Dealer/Workshop Code
            </th>
            <th nxHeaderCell nxSortHeaderCell="workshop_Name">
                Dealer/Workshop Name
            </th>
            <th nxHeaderCell nxSortHeaderCell="paymentDate">
                Payment Date
            </th>
            <th nxHeaderCell nxSortHeaderCell="totalCount">
                Total Count
            </th>
            <th nxHeaderCell nxSortHeaderCell="totalAmount">
                Total Amount
            </th>
        </tr>
    </thead>
    <tbody class="txtalign_center">
        <tr nxTableRow *ngFor="let Req of ReportData">
            <td nxTableCell>{{Req.zone}}</td>
            <td nxTableCell>{{Req.state_Name}}</td>
            <td nxTableCell>{{Req.city_Name}}</td>
            <td nxTableCell>{{Req.dealerOrWorkshopCode}}</td>
            <td nxTableCell>{{Req.workshop_Name}}</td>
            <td nxTableCell>{{Req.paymentDate | date:'MM/dd/yyyy'}}</td>
            <td nxTableCell>{{Req.totalCount}}</td>
            <td nxTableCell>{{Req.totalAmount}}</td>
        </tr>
        <tr nxTableRow *ngIf="count==0">
            <td nxTableCell colspan="7">
                <ng-container>
                    <div nxRow rowJustify="center">
                        <div nxCol="12" class="nosearchresult"></div>
                        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">No Records found
                            !!!</h3>
                    </div>
                </ng-container>
            </td>
        </tr>
    </tbody>
</table>
<div nxRow class="fright">
    <div nxCol="6">
        <nx-pagination [count]="count" [page]="pageNumber" [perPage]="pageSize" type="advanced" (goPrev)="prevPage()"
            (goNext)="nextPage()" (goPage)="goToPage($event)">
        </nx-pagination>
    </div>
</div>